const initialValues = {
  user: {},
  cart: [],
};

export default initialValues;
